import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(Item(), {
    state() {
        return {
            id: null,
            log_name: null,
            description: null,
            subject_id: null,
            subject_type: null,
            course_id: null,
            course: null,
            context: null,
            contextual_subject: null,
            causer_id: null,
            causer_type: null,
            properties: null,
            updated_at: null,
            created_at: null,

            order: null,
        };
    },

    getters: {
        id: state => {
            return state.id;
        },
    },
});
